<label class="form-field-label" [class.is-required]="required" [attr.for]="forId || null">{{ text }}</label>